import {
	fetchUsersWithoutCompensationData,
	getCompensationCycleDetails,
	getCompensationMyDecisionDetails,
	getCompensationPermissions,
	getCompensationSettings,
	getSelectionManagers,
	getSelectionSalarySummary,
	listCompensationCycles,
	listCompensationCyclesWithMyDecisions,
} from "../../services/defs/internal-api/compensation";

export const compensationSettingsQuery = () => ({
	queryKey: ["compensation-settings"],
	queryFn: () => getCompensationSettings(),
	meta: {
		errorMessage: "There was an error getting the compensation settings.",
	},
});

export const compensationPermissionsQuery = () => ({
	queryKey: ["compensation-permissions"],
	queryFn: () => getCompensationPermissions(),
	meta: {
		errorMessage: "There was an error getting the compensation permissions.",
	},
});

export const compensationCycleListQuery = (params: {
	skip?: number;
	limit?: number;
	sort?: string;
	search?: string;
	status?: string;
}) => ({
	queryKey: ["compensation-cycles", params],
	queryFn: () => listCompensationCycles(params),
	meta: {
		errorMessage: "There was an error loading the compensation cycles.",
	},
});

export const compensationCycleListWithMyDecisionsQuery = (params: {
	skip?: number;
	limit?: number;
	sort?: string;
	search?: string;
	status?: string;
}) => ({
	queryKey: ["compensation-cycles", "my-decisions", params],
	queryFn: () => listCompensationCyclesWithMyDecisions(params),
	meta: {
		errorMessage: "There was an error loading your compensation cycles.",
	},
});

export const selectionSalarySummaryQuery = (userSelectionId: string) => ({
	queryKey: ["compensation", "selection-salary-summary", userSelectionId],
	queryFn: () => getSelectionSalarySummary(userSelectionId),
	meta: {
		errorMessage: "There was an error getting the salary summary.",
	},
});

export const selectionManagersQuery = (
	userSelectionId: string,
	params?: {
		skip?: number;
		limit?: number;
		sortBy?: "name" | "directReportCount" | "totalCompensation";
		sortOrder?: "asc" | "desc";
		search?: string;
	}
) => ({
	queryKey: ["compensation", "selection-managers", userSelectionId, params],
	queryFn: () => getSelectionManagers(userSelectionId, params),
	meta: {
		errorMessage: "There was an error getting the selection managers.",
	},
});

export const compensationCycleDetailsQuery = (cycleId: string) => ({
	queryKey: ["compensation-cycle-details", cycleId],
	queryFn: () => getCompensationCycleDetails(cycleId),
	meta: {
		errorMessage: "There was an error getting the compensation cycle details.",
	},
});

export const compensationMyDecisionDetailsQuery = (userId: string, cycleId: string) => ({
	queryKey: ["compensation-my-decision-details", userId, cycleId],
	queryFn: () => getCompensationMyDecisionDetails(userId, cycleId),
	meta: {
		errorMessage: "There was an error getting the compensation cycle, my decision details.",
	},
});
export const getUsersWithoutCompensationDataQuery = () => ({
	queryKey: ["UsersWithoutCompensationData"],
	queryFn: () => fetchUsersWithoutCompensationData(),
	meta: {
		errorMessage: "There was an error fetching users missing compensation data.",
	},
});
